import { render, staticRenderFns } from "./awardDetail.vue?vue&type=template&id=3d206786&scoped=true"
import script from "./awardDetail.vue?vue&type=script&lang=js"
export * from "./awardDetail.vue?vue&type=script&lang=js"
import style0 from "./awardDetail.vue?vue&type=style&index=0&id=3d206786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d206786",
  null
  
)

export default component.exports